(window.shopifySlateJsonp = window.shopifySlateJsonp || []).push([[46], {
    141: function(t, n, e) {
        "use strict";
        e.r(n);
        var r = e(484)
          , a = e(425);
        for (var i in a)
            "default" !== i && function(t) {
                e.d(n, t, function() {
                    return a[t]
                })
            }(i);
        var s = e(291)
          , o = Object(s.a)(a.default, r.a, r.b, !1, null, null, null);
        n.default = o.exports
    },
    291: function(t, n, e) {
        "use strict";
        function r(t, n, e, r, a, i, s, o) {
            var u, c = "function" == typeof t ? t.options : t;
            if (n && (c.render = n,
            c.staticRenderFns = e,
            c._compiled = !0),
            r && (c.functional = !0),
            i && (c._scopeId = "data-v-" + i),
            s ? (u = function(t) {
                (t = t || this.$vnode && this.$vnode.ssrContext || this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) || "undefined" == typeof __VUE_SSR_CONTEXT__ || (t = __VUE_SSR_CONTEXT__),
                a && a.call(this, t),
                t && t._registeredComponents && t._registeredComponents.add(s)
            }
            ,
            c._ssrRegister = u) : a && (u = o ? function() {
                a.call(this, (c.functional ? this.parent : this).$root.$options.shadowRoot)
            }
            : a),
            u)
                if (c.functional) {
                    c._injectStyles = u;
                    var l = c.render;
                    c.render = function(t, n) {
                        return u.call(n),
                        l(t, n)
                    }
                } else {
                    var f = c.beforeCreate;
                    c.beforeCreate = f ? [].concat(f, u) : [u]
                }
            return {
                exports: t,
                options: c
            }
        }
        e.d(n, "a", function() {
            return r
        })
    },
    425: function(t, n, e) {
        "use strict";
        e.r(n);
        var r = e(426)
          , a = e.n(r);
        for (var i in r)
            "default" !== i && function(t) {
                e.d(n, t, function() {
                    return r[t]
                })
            }(i);
        n.default = a.a
    },
    426: function(t, n, e) {
        "use strict";
        Object.defineProperty(n, "__esModule", {
            value: !0
        }),
        n.default = {
            name: "KlarnaCreditPromotion",
            props: {
                settings: Object,
                variant_price: Number,
                klarna_minimum_amount: Number
            },
            data: function() {
                return {}
            },
            mounted: function() {
                this.refreshKlarnaPlacements()
            },
            watch: {
                klarnaPurchaseAmount: function() {
                    this.refreshKlarnaPlacements()
                }
            },
            methods: {
                refreshKlarnaPlacements: function() {
                    this.settings.showKlarnaWidget && this.$nextTick(function() {
                        window.KlarnaOnsiteService = window.KlarnaOnsiteService || [],
                        window.KlarnaOnsiteService.push({
                            eventName: "refresh-placements"
                        })
                    })
                }
            },
            computed: {
                cart: function() {
                    return this.$store.state.cart.content
                },
                subtotal: function() {
                    return this.cart.items_subtotal_price
                },
                klarnaPurchaseAmount: function() {
                    return this.variant_price > this.klarnaFormatedMinimumAmount ? this.variant_price : this.subtotal > 0 && this.settings.considerCart ? this.subtotal : 10
                },
                klarnaFormatedMinimumAmount: function() {
                    return 100 * this.settings.klarnaMinimumAmount
                }
            }
        }
    },
    484: function(t, n, e) {
        "use strict";
        var r = function() {
            var t = this.$createElement
              , n = this._self._c || t;
            return this.settings.showKlarnaWidget ? n("klarna-placement", {
                staticClass: "product__info-wrapper__klarna-widget",
                attrs: {
                    "data-key": "credit-promotion-badge",
                    "data-locale": this.settings.klarnaLocale,
                    "data-purchase-amount": this.klarnaPurchaseAmount
                }
            }) : this._e()
        }
          , a = [];
        e.d(n, "a", function() {
            return r
        }),
        e.d(n, "b", function() {
            return a
        })
    }
}]);
